import dayjs from 'dayjs';
export const DEFAULT_DATE_RANGE_INDEX = 2;
export const dateRangeOptions = [
    {
        label: 'Today',
        value: 'today',
        dates: [dayjs().startOf('day').toDate(), dayjs().endOf('day').toDate()],
    },
    {
        label: 'Yesterday',
        value: 'yesterday',
        dates: [
            dayjs().subtract(1, 'day').startOf('day').toDate(),
            dayjs().subtract(1, 'day').endOf('day').toDate(),
        ],
    },
    {
        label: 'Last 7 days',
        value: 'last7days',
        dates: [dayjs().subtract(7, 'day').startOf('day').toDate(), dayjs().endOf('day').toDate()],
    },
    {
        label: 'Last 30 days',
        value: 'last30days',
        dates: [dayjs().subtract(30, 'day').startOf('day').toDate(), dayjs().endOf('day').toDate()],
    },
    {
        label: 'Last 90 days',
        value: 'last90days',
        dates: [dayjs().subtract(90, 'day').startOf('day').toDate(), dayjs().endOf('day').toDate()],
    },
    {
        label: 'Week to date',
        value: 'weekToDate',
        dates: [dayjs().startOf('week').toDate(), dayjs().endOf('day').toDate()],
    },
    {
        label: 'Month to date',
        value: 'monthToDate',
        dates: [dayjs().startOf('month').toDate(), dayjs().endOf('day').toDate()],
    },
    {
        label: 'Year to date',
        value: 'yearToDate',
        dates: [dayjs().startOf('year').toDate(), dayjs().endOf('day').toDate()],
    },
    {
        label: 'Last month',
        value: 'lastMonth',
        dates: [
            dayjs().subtract(1, 'month').startOf('month').toDate(),
            dayjs().subtract(1, 'month').endOf('month').toDate(),
        ],
    },
];
